module.exports = __webpack_public_path__ + "static/media/Kingrose_Villa_2.db477f95.pdf";